var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4001 13.6C17.5399 13.6 13.6 17.5399 13.6 22.4001C13.6 27.2602 17.5399 31.2001 22.4001 31.2001C27.2602 31.2001 31.2001 27.2602 31.2001 22.4001C31.2001 17.5399 27.2602 13.6 22.4001 13.6ZM12 22.4001C12 16.6563 16.6563 12 22.4001 12C28.1439 12 32.8001 16.6563 32.8001 22.4001C32.8001 28.1439 28.1439 32.8001 22.4001 32.8001C16.6563 32.8001 12 28.1439 12 22.4001Z",
    fill: "#1D2129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0344 29.0351C29.3468 28.7227 29.8534 28.7227 30.1659 29.0351L35.7665 34.6358C36.079 34.9482 36.079 35.4548 35.7665 35.7673C35.4541 36.0797 34.9475 36.0797 34.635 35.7673L29.0344 30.1666C28.7219 29.8542 28.7219 29.3476 29.0344 29.0351Z",
    fill: "#1D2129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4004 18.3985C22.8422 18.3985 23.2004 18.7567 23.2004 19.1986V21.5989H25.6007C26.0426 21.5989 26.4008 21.9571 26.4008 22.3989C26.4008 22.8408 26.0426 23.199 25.6007 23.199H23.2004V25.5993C23.2004 26.0412 22.8422 26.3994 22.4004 26.3994C21.9585 26.3994 21.6003 26.0412 21.6003 25.5993V23.199H19.2C18.7581 23.199 18.3999 22.8408 18.3999 22.3989C18.3999 21.9571 18.7581 21.5989 19.2 21.5989H21.6003V19.1986C21.6003 18.7567 21.9585 18.3985 22.4004 18.3985Z",
    fill: "#1D2129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.3142a1d5a2b48d2362f507a90ae98988.svg";
export { ForwardRef as ReactComponent };